import React, { useState, useEffect, useRef } from 'react';

export default function CatalogCombobox({ catalogItems, value, onSelect, canAddNew, onAddNew }) {
  const [query, setQuery]       = useState('');
  const [open, setOpen]         = useState(false);
  const [dropPos, setDropPos]   = useState({ top: 0, left: 0, width: 0 });
  const inputRef = useRef(null);
  const dropRef  = useRef(null);

  const selected = catalogItems.find(c => String(c.id) === String(value));

  useEffect(() => {
    if (selected) setQuery(`${selected.name}${selected.catalog_number ? ` [${selected.catalog_number}]` : ''}`);
    else if (!value) setQuery('');
  }, [selected, value]);

  useEffect(() => {
    const handler = e => {
      if (inputRef.current && !inputRef.current.closest('[data-combobox]').contains(e.target) &&
          dropRef.current && !dropRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const openDrop = () => {
    if (inputRef.current) {
      const r = inputRef.current.getBoundingClientRect();
      setDropPos({ top: r.bottom, left: r.left, width: r.width });
    }
    setOpen(true);
  };

  const filtered = query.trim()
    ? catalogItems.filter(c =>
        c.name.toLowerCase().includes(query.toLowerCase()) ||
        (c.catalog_number || '').toLowerCase().includes(query.toLowerCase()) ||
        (c.cas_number || '').toLowerCase().includes(query.toLowerCase())
      ).slice(0, 20)
    : catalogItems.slice(0, 20);

  const handleSelect = item => {
    setQuery(`${item.name}${item.catalog_number ? ` [${item.catalog_number}]` : ''}`);
    setOpen(false);
    onSelect(item.id);
  };

  return (
    <div data-combobox style={{ position: 'relative' }}>
      <div style={{ position: 'relative', display: 'flex', gap: 4 }}>
        <div style={{ position: 'relative', flex: 1 }}>
          <input
            ref={inputRef}
            className="form-control"
            style={{ fontSize: '0.82rem' }}
            placeholder="Search product…"
            value={query}
            onChange={e => { setQuery(e.target.value); openDrop(); if (!e.target.value) onSelect(''); }}
            onFocus={openDrop}
          />
          {value && (
            <button type="button" onClick={() => { setQuery(''); setOpen(false); onSelect(''); }}
              style={{ position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', fontSize: 16, lineHeight: 1 }}>
              ×
            </button>
          )}
        </div>
        {canAddNew && (
          <button type="button" className="btn btn-secondary btn-sm" onClick={onAddNew}
            style={{ whiteSpace: 'nowrap', fontSize: '0.75rem' }}>＋</button>
        )}
      </div>
      {open && (filtered.length > 0 || canAddNew) && (
        <div ref={dropRef} style={{
          position: 'fixed', top: dropPos.top, left: dropPos.left, width: dropPos.width, zIndex: 9999,
          background: '#fff', border: '1px solid var(--border)', borderRadius: 8,
          boxShadow: '0 4px 20px rgba(0,0,0,0.12)', maxHeight: 240, overflowY: 'auto',
        }}>
          {canAddNew && (
            <div onMouseDown={e => { e.preventDefault(); setOpen(false); onAddNew(); }}
              style={{ padding: '7px 12px', cursor: 'pointer', color: 'var(--primary)', fontWeight: 600, fontSize: '0.82rem', borderBottom: '1px solid var(--border)' }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--primary-lighter)'}
              onMouseLeave={e => e.currentTarget.style.background = ''}>
              ＋ Add New Product…
            </div>
          )}
          {filtered.map(item => (
            <div key={item.id} onMouseDown={e => { e.preventDefault(); handleSelect(item); }}
              style={{ padding: '7px 12px', cursor: 'pointer', borderBottom: '1px solid var(--border-light)' }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--primary-lighter)'}
              onMouseLeave={e => e.currentTarget.style.background = ''}>
              <div style={{ fontWeight: 600, fontSize: '0.82rem' }}>{item.name}</div>
              {(item.catalog_number || item.cas_number) && (
                <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>
                  {[item.catalog_number && `Cat: ${item.catalog_number}`, item.cas_number && `CAS: ${item.cas_number}`].filter(Boolean).join('  ·  ')}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
